import { Icon, Tooltip } from 'antd';
import React, { useCallback } from 'react';
import styles from './ControlDateWithActions.module.scss';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import CellText from '../../../CellText/CellText';
import { ignoredExecutionTime } from '../../../../../constants/ignoredExecutionTime';
import { openModalAlertDate } from '../../../../../actions/alert-date.actions';

const render = (request) => {
  const dateTimeInstance = moment(request?.alertDateTime);
  const time = dateTimeInstance.format('HH:mm');
  const hoursFormat = ignoredExecutionTime.includes(time) ? '' : 'HH:mm';
  const dayFormat = 'DD.MM.YYYY';
  const format = [dayFormat, hoursFormat].filter(Boolean).join(' ');
  return dateTimeInstance.format(format);
};

const ControlDate = ({ onClick, request, isActive, className, ...props }) => {
  const content = render(request);

  return (
    <span
      {...props}
      className={cn(styles.root, className, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
    >
      <Icon
        type="info-circle"
        style={{ color: 'gray', fontSize: '12px', marginRight: 5 }}
      />
      <span>{content}</span>
    </span>
  );
};

const useChangeControlDate = (request) => {
  const { CanChangeExecuteDate } = useSelector(
    (state) => state.authentication.userInfo
  );
  const dispatch = useDispatch();

  const onClick = useCallback(
    (e) => {
      e.stopPropagation();
      dispatch(openModalAlertDate({ data: request }));
    },
    [dispatch, request]
  );

  return { isActive: CanChangeExecuteDate, onClick };
};

const ChangeControlDate = ({ request, canChange }) => {
  const { isActive: canControlDateChange, onClick } =
    useChangeControlDate(request);

  const isActive = canControlDateChange && canChange;

  return (
    <Tooltip
      title={isActive ? 'Изменить дату контроля' : 'Дата контроля'}
      mouseLeaveDelay={0}
    >
      <ControlDate
        onClick={isActive ? onClick : undefined}
        request={request}
        isActive={isActive}
      />
    </Tooltip>
  );
};

const ControlDateWithActions = ({ request, canChange = true }) => {
  return (
    <ChangeControlDate
      request={request}
      canChange={canChange}
    />
  );
};

export default ControlDateWithActions;
